import React, { ReactNode } from 'react';
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import { uniqueId } from 'lodash';
import { ROLES_LIST } from '@modules/Roles/constants/roles';
import styles from './ActionButtons.module.scss';

interface Props {
  roleId?: string;
  onEdit?: () => void;
  onDelete?: () => void;
  onPreview?: () => void;
  tooltips?: {
    edit?: ReactNode;
    delete?: ReactNode;
    preview?: ReactNode;
  };
  preset?: boolean;
}

const { Compact } = Space;

const ActionButtons: React.FC<Props> = (props) => {
  const { roleId = uniqueId(), onPreview, onEdit, onDelete, tooltips = {}, preset = false } = props;

  return (
    <Compact className={styles.actionButtons}>
      <Tooltip title={tooltips?.preview || ROLES_LIST.TOOLTIPS.VIEW} placement="topLeft">
        <Button
          data-testid={`btn-${roleId}-view`}
          type="link"
          size="small"
          icon={<EyeOutlined />}
          onClick={onPreview}
        />
      </Tooltip>
      {!preset && (
        <>
          <Tooltip title={tooltips?.edit || ROLES_LIST.TOOLTIPS.EDIT} placement="topLeft">
            <Button
              data-testid={`btn-${roleId}-edit`}
              type="link"
              size="small"
              icon={<EditOutlined />}
              onClick={onEdit}
            />
          </Tooltip>
          <Tooltip title={tooltips?.delete || ROLES_LIST.TOOLTIPS.DELETE} placement="topLeft">
            <Button
              data-testid={`btn-${roleId}-delete`}
              type="link"
              size="small"
              icon={<DeleteOutlined />}
              onClick={onDelete}
              danger
            />
          </Tooltip>
        </>
      )}
    </Compact>
  );
};

export default ActionButtons;
